import React from "react";

const MailIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={19} height={14}>
            <title>{"755C6027-40EF-475E-8803-B3B9D7D849E9"}</title>
            <g fill="#006AE3" fillRule="nonzero">
                <path d="M18.55 2.174c-.024-1.131-.909-2.053-1.965-2.053H2.191C1.135.121.25 1.041.226 2.174l9.162 4.79 9.163-4.79Z" />
                <path d="M18.477 3.937 9.683 8.543a.716.716 0 0 1-.32.078.471.471 0 0 1-.27-.078L.3 3.937v7.764c-.024 1.132.81 2.08 1.867 2.106H16.586c1.056-.026 1.916-.947 1.89-2.08v-7.79Z" />
            </g>
        </svg>
    );
};

export default MailIcon;
